import { useEffect, type ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { readPostTryOnCompletion } from '../exit/session-completion-guard'
import { emitPostTryOnTelemetry } from '../telemetry/post-tryon-telemetry'

type Props = {
  children: ReactNode
}

export function PostTryOnRouteGuard({ children }: Props) {
  const location = useLocation()
  const completion = readPostTryOnCompletion(location)

  useEffect(() => {
    if (!completion) return
    emitPostTryOnTelemetry('post_try_on_session_restore_blocked', { sessionId: completion.journeyId, productType: completion.productType, checkoutStatus: completion.checkoutStatus })
  }, [completion])

  if (completion) return <Navigate to="/experience-completed" replace />
  return children
}
